const ProjectList = [
  {
    id: 1,
    src: "./assets/ratethegords.png",
    altTag: "Rate The Gords",
    name: "Rate The Gords",
    details: "A place to rate Canada's iconic Gords",
    specs: "MongoDB | Express | React.js | Node.js | JavaScript",
    deployedUrl: "https://ratethegords.herokuapp.com/",
    githubRepo: "https://github.com/AmyWilford/RatetheGords",
  },
  {
    id: 2,
    src: "./assets/boq-gpo.png",
    altTag: "Bay of Quinte, Green Party of Ontario",
    name: "Bay of Quinte Green Party of Ontario",
    specs: "Wordpress | Custom HTML & CSS",
    details: "Custom website build for local Green Party of Ontario riding, Bay of Quinte.",
    deployedUrl: "https://bayofquintegpo.ca/",
    githubRepo: "https://github.com/AmyWilford",
  },
  {
    id: 3,
    src: "./assets/cuecards.png",
    altTag: "CueCards",
    name: "Cue Cards: Online Study Tool",
    details: "An online study tool - make your own cuecards and quiz yourself.",
    specs: "MongoDB | Express | React.js | Node.js | JavaScript",
    deployedUrl: "https://cuecards-aw22.herokuapp.com/",
    githubRepo: "https://github.com/AmyWilford/cuecards",
  },
  {
    id: 4,
    src: "./assets/javascript-1.png",
    altTag: "JavaScript Mug Store Home Page",
    name: "Javascript Custom Mugs",
    specs: "MERN | GraphQL | Stripe | JWT | JavaScript",
    details: "A fullstack e-commerce store for unique customized mugs",
    deployedUrl: "https://whispering-inlet-47426.herokuapp.com/",
    githubRepo: "https://github.com/AmyWilford/Mug-Store",
  },
  {
    id: 5,
    src: "./assets/techspace-1.png",
    altTag: "Techspace Blog Home page",
    name: "techspace",
    details: "Fullstack CMS technology blogging site",
    specs: "MySQL | Sequelize | Handlebars | JavaScript | Bcrypt",
    deployedUrl: "https://radiant-plains-16714.herokuapp.com/",
    githubRepo: "https://github.com/AmyWilford/Tech-Space---CMS-Blog",
  },
  {
    id: 6,
    src: "./assets/weather-1.png",
    altTag: "weather dashboard homepage",
    name: "Weather Dashboard",
    details: "Get up to date weather forecasts wherever your plans take you",
    specs: "JavaScript | JQuery | Open Weather API ",
    deployedUrl: "https://amywilford.github.io/Weather-Dashboard/",
    githubRepo: "https://github.com/AmyWilford/Weather-Dashboard",
  },



];

export default ProjectList;
